import React from 'react';

// The card shell every analytics section shares: heading + right-aligned meta,
// a one-line explanation of what the reader is looking at, the content, and an
// optional footnote rule at the bottom.
export default function SectionCard({ title, meta, lede, footer, children, style }) {
  return (
    <section
      className="pp-card"
      style={{ padding: '20px 22px', display: 'flex', flexDirection: 'column', ...style }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'baseline',
          justifyContent: 'space-between',
          gap: 12,
          flexWrap: 'wrap',
          marginBottom: 4,
        }}
      >
        <h2
          style={{
            margin: 0,
            fontSize: 'var(--text-panel-size)',
            fontWeight: 'var(--text-panel-weight)',
            letterSpacing: '-0.012em',
            color: 'var(--text-primary)',
          }}
        >
          {title}
        </h2>
        {meta && (
          <span style={{ fontSize: 11.5, color: 'var(--text-tertiary)' }}>{meta}</span>
        )}
      </div>
      {lede && (
        <p style={{ margin: '0 0 18px', fontSize: 13, lineHeight: 1.5, color: 'var(--text-secondary)' }}>
          {lede}
        </p>
      )}
      {/* Absorbs leftover height so the footnote rule sits at the card's bottom
          edge when a neighbouring card in the same row is taller. */}
      <div style={{ flex: 1, minWidth: 0 }}>{children}</div>
      {footer && (
        <p
          style={{
            margin: '16px 0 0',
            paddingTop: 13,
            borderTop: '1px solid var(--border-subtle)',
            fontSize: 12,
            lineHeight: 1.5,
            color: 'var(--text-tertiary)',
          }}
        >
          {footer}
        </p>
      )}
    </section>
  );
}
